<section class="content-section dc-page">

  <!-- ── En-tête ─────────────────────────────────────────────────── -->
  <div class="dc-header">
    <div class="dc-header-left">
      <h2 class="dc-title"><i class="fal fa-calculator-alt"></i> Comptabilité</h2>
      <span class="dc-scope-badge" *ngIf="data">
        <i class="fal fa-globe-africa"></i> {{ data.scope }}
      </span>
    </div>
    <div class="dc-header-right">
      <span class="dc-refresh-time" *ngIf="derniereMaj">Mis à jour à {{ derniereMaj }}</span>
      <button class="btn btn-outline dc-btn-refresh" (click)="recharger()" [disabled]="chargement">
        <i class="fal fa-sync-alt" [class.fa-spin]="chargement"></i> Actualiser
      </button>
    </div>
  </div>

  <!-- ── Filtre de période ────────────────────────────────────────── -->
  <div class="dc-periode-bar">
    <div class="dc-periode-tabs">
      <button *ngFor="let p of PERIODES"
              class="dc-periode-tab"
              [class.dc-periode-tab--active]="periodeSelectionnee === p.val"
              (click)="appliquerPeriode(p.val)">
        {{ p.label }}
      </button>
    </div>
    <div class="dc-periode-custom" *ngIf="periodeSelectionnee === 'CUSTOM'">
      <input type="date" class="dc-date-input" [(ngModel)]="dateDebut" />
      <span style="color: var(--text-secondary);">→</span>
      <input type="date" class="dc-date-input" [(ngModel)]="dateFin" />
      <button class="btn btn-primary dc-btn-apply" (click)="recharger()">
        <i class="fal fa-check"></i> Appliquer
      </button>
    </div>
    <span class="dc-periode-label" *ngIf="periodeSelectionnee !== 'CUSTOM' && (dateDebut || dateFin)">
      {{ dateDebut }} → {{ dateFin || 'aujourd\'hui' }}
    </span>
  </div>

  <!-- ── Skeleton ─────────────────────────────────────────────────── -->
  <div *ngIf="chargement" class="dc-skeleton-wrap">
    <div class="dc-skeleton-kpis">
      <div class="dc-skeleton-card" *ngFor="let i of [1,2,3,4]"></div>
    </div>
    <div class="dc-skeleton-row">
      <div class="dc-skeleton-card dc-skeleton-card--tall"></div>
      <div class="dc-skeleton-card dc-skeleton-card--tall"></div>
    </div>
  </div>

  <ng-container *ngIf="!chargement && data">

    <!-- ── KPIs ──────────────────────────────────────────────────── -->
    <div class="dc-kpi-row">
      <div class="dc-kpi dc-kpi--blue">
        <div class="dc-kpi-icon"><i class="fal fa-receipt"></i></div>
        <div class="dc-kpi-body">
          <span class="dc-kpi-label">Total attendu (livrées)</span>
          <strong class="dc-kpi-val">{{ formaterFCFA(data.totalAttenduLivrees) }}</strong>
          <span class="dc-kpi-sub">montants à encaisser</span>
        </div>
      </div>

      <div class="dc-kpi dc-kpi--green">
        <div class="dc-kpi-icon"><i class="fal fa-hand-holding-usd"></i></div>
        <div class="dc-kpi-body">
          <span class="dc-kpi-label">Déclaré par les livreurs</span>
          <strong class="dc-kpi-val">{{ formaterFCFA(data.totalEncaisseLivreurs) }}</strong>
          <span class="dc-kpi-sub" *ngIf="data.totalAttenduLivrees > 0">
            {{ tauxEncaissement() }}% du total attendu
          </span>
        </div>
      </div>

      <div class="dc-kpi" [ngClass]="data.resteARegulariser > 0 ? 'dc-kpi--orange' : 'dc-kpi--grey'">
        <div class="dc-kpi-icon"><i class="fal fa-exclamation-triangle"></i></div>
        <div class="dc-kpi-body">
          <span class="dc-kpi-label">Reste à régulariser</span>
          <strong class="dc-kpi-val">{{ formaterFCFA(data.resteARegulariser) }}</strong>
          <span class="dc-kpi-sub" *ngIf="data.resteARegulariser === 0" style="color:#059669">Tout est collecté ✓</span>
          <span class="dc-kpi-sub" *ngIf="data.nbLivreesSansEncaissement > 0" style="color:#ea580c">
            dont {{ data.nbLivreesSansEncaissement }} sans déclaration
          </span>
        </div>
      </div>

      <div class="dc-kpi" [ngClass]="data.encaissementsNonValides > 0 ? 'dc-kpi--red' : 'dc-kpi--grey'">
        <div class="dc-kpi-icon"><i class="fal fa-clock"></i></div>
        <div class="dc-kpi-body">
          <span class="dc-kpi-label">En attente validation</span>
          <strong class="dc-kpi-val">{{ data.encaissementsNonValides }}</strong>
          <span class="dc-kpi-sub" *ngIf="data.encaissementsNonValides > 0" style="color:#dc2626">
            à vérifier par la compta
          </span>
        </div>
      </div>
    </div>

    <!-- ── Barre de collecte globale ────────────────────────────── -->
    <div class="dc-collecte-bar" *ngIf="data.totalAttenduLivrees > 0">
      <div class="dc-collecte-bar-header">
        <span>Taux de collecte global — {{ labelPeriode }}</span>
        <strong>{{ tauxEncaissement() }}%</strong>
      </div>
      <div class="dc-collecte-track">
        <div class="dc-collecte-fill dc-collecte-fill--encaisse"
             [style.width.%]="tauxEncaissement()"></div>
      </div>
      <div class="dc-collecte-legend">
        <span class="dc-legend-dot dc-legend-dot--green"></span> Déclaré encaissé
        <span class="dc-legend-dot dc-legend-dot--orange" style="margin-left: 16px;"></span> Non encore déclaré
      </div>
    </div>

    <!-- ── Ligne 2 : Modes + Suivi ───────────────────────────────── -->
    <div class="dc-mid-row">

      <div class="dc-card">
        <h4 class="dc-card-title"><i class="fal fa-chart-pie"></i> Encaissements par mode (livreurs)</h4>
        <p class="dc-card-hint">Modes déclarés par les livreurs sur le mobile lors de la livraison</p>
        <div *ngIf="entries(data.encaisseParMode).length === 0" class="dc-empty-small">
          Aucun encaissement déclaré sur la période
        </div>
        <div class="dc-modes-list" *ngIf="entries(data.encaisseParMode).length > 0">
          <div class="dc-mode-item" *ngFor="let e of entries(data.encaisseParMode)">
            <div class="dc-mode-left">
              <span class="dc-mode-icon" [ngClass]="modeIconClass(e.key)">
                <i class="fal" [ngClass]="modeIcon(e.key)"></i>
              </span>
              <span class="dc-mode-label">{{ modeLabel(e.key) }}</span>
            </div>
            <div class="dc-mode-right">
              <div class="dc-mode-bar-bg">
                <div class="dc-mode-bar-fill" [style.width.%]="modePct(e.value)"
                     [ngClass]="modeBarClass(e.key)"></div>
              </div>
              <strong class="dc-mode-val">{{ formaterFCFA(e.value) }}</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="dc-card">
        <h4 class="dc-card-title"><i class="fal fa-tasks-alt"></i> Suivi règlement</h4>
        <div class="dc-suivi-grid">
          <div class="dc-suivi-item" [ngClass]="data.nbVirementTraiteATraiter > 0 ? 'dc-suivi-item--warn' : 'dc-suivi-item--ok'">
            <span class="dc-suivi-count">{{ data.nbVirementTraiteATraiter }}</span>
            <span class="dc-suivi-desc">Virements / traites à traiter</span>
          </div>
          <div class="dc-suivi-item dc-suivi-item--blue">
            <span class="dc-suivi-count">{{ data.encaissementsValides }}</span>
            <span class="dc-suivi-desc">Validés par la comptabilité</span>
          </div>
          <div class="dc-suivi-item" [ngClass]="data.encaissementsNonValides > 0 ? 'dc-suivi-item--red' : 'dc-suivi-item--ok'">
            <span class="dc-suivi-count">{{ data.encaissementsNonValides }}</span>
            <span class="dc-suivi-desc">Déclarés, non encore validés</span>
          </div>
          <div class="dc-suivi-item" [ngClass]="data.nbLivreesSansEncaissement > 0 ? 'dc-suivi-item--warn' : 'dc-suivi-item--ok'">
            <span class="dc-suivi-count">{{ data.nbLivreesSansEncaissement }}</span>
            <span class="dc-suivi-desc">Livrés sans déclaration livreur</span>
          </div>
        </div>
        <div class="dc-valid-bar-section" *ngIf="(data.encaissementsValides + data.encaissementsNonValides) > 0">
          <div class="dc-valid-bar-label">
            <span>Taux de validation</span><span>{{ tauxValidation() }}%</span>
          </div>
          <div class="dc-valid-bar-bg">
            <div class="dc-valid-bar-fill" [style.width.%]="tauxValidation()"></div>
          </div>
          <p class="dc-valid-bar-hint">Délai moyen de validation : <strong>{{ data.delaiMoyenValidationHeures }}h</strong></p>
        </div>
      </div>
    </div>

    <!-- ── Table validation ──────────────────────────────────────── -->
    <div class="dc-card">
      <div class="dc-table-header">
        <div>
          <h4 class="dc-card-title" style="margin: 0;">
            <i class="fal fa-clipboard-check"></i> Encaissements livreurs
          </h4>
          <p class="dc-card-hint" style="margin: 4px 0 0;">
            Données saisies par les livreurs sur l'application mobile au moment de la livraison
          </p>
        </div>
        <div class="dc-search-wrap">
          <i class="fal fa-search dc-search-icon"></i>
          <input class="dc-search-input" type="search" [(ngModel)]="rechercheCommande"
                 placeholder="N° commande, livreur…" />
        </div>
      </div>

      <!-- Onglets -->
      <div class="dc-onglets">
        <button class="dc-onglet" [class.dc-onglet--active]="ongletActif === 'DECLARATION'"
                (click)="ongletActif = 'DECLARATION'">
          <i class="fal fa-check-circle"></i>
          Déclarés par livreur
          <span class="dc-onglet-badge dc-onglet-badge--orange" *ngIf="lignesDeclaration.length > 0">
            {{ lignesDeclaration.length }}
          </span>
        </button>
        <button class="dc-onglet" [class.dc-onglet--active]="ongletActif === 'SANS_DECLARATION'"
                (click)="ongletActif = 'SANS_DECLARATION'">
          <i class="fal fa-exclamation-circle"></i>
          Sans déclaration livreur
          <span class="dc-onglet-badge dc-onglet-badge--red" *ngIf="lignesSansDeclaration.length > 0">
            {{ lignesSansDeclaration.length }}
          </span>
        </button>
      </div>

      <!-- ── Onglet 1 : Déclarés par livreur, non encore validés ── -->
      <ng-container *ngIf="ongletActif === 'DECLARATION'">
        <div class="dc-empty" *ngIf="lignesDeclaration.length === 0">
          <i class="fal fa-check-circle" style="font-size:2.5rem;color:#22c55e;margin-bottom:8px;"></i>
          <p>Aucune déclaration en attente de validation</p>
          <small>Tous les encaissements déclarés ont été traités.</small>
        </div>
        <div class="dc-table-wrap" *ngIf="lignesDeclaration.length > 0">
          <table class="dc-table">
            <thead>
              <tr>
                <th>Commande</th>
                <th>Livreur</th>
                <th>Attendu</th>
                <th>Déclaré encaissé</th>
                <th>Écart</th>
                <th>Mode encaissement</th>
                <th>Référence</th>
                <th>Déclaré le</th>
                <th>Note livreur</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of lignesDeclaration"
                  [class.dc-row--ecart]="ecart(r) !== 0">
                <td><span class="dc-cmd-num">{{ r.numeroCommande }}</span></td>
                <td>
                  <span class="dc-livreur">
                    <i class="fal fa-user-circle" style="color:var(--primary-color)"></i>
                    {{ r.livreurNom || '—' }}
                  </span>
                </td>
                <td class="dc-num-cell">{{ formaterFCFA(r.montantAttendu) }}</td>
                <td class="dc-num-cell"><strong>{{ formaterFCFA(r.montantEncaisse) }}</strong></td>
                <td class="dc-num-cell">
                  <span class="dc-ecart-badge" *ngIf="ecart(r) !== 0" [class.dc-ecart--neg]="ecart(r) < 0">
                    {{ ecart(r) > 0 ? '+' : '' }}{{ ecart(r) | number:'1.0-0' }} F
                  </span>
                  <span *ngIf="ecart(r) === 0" class="dc-ok-check">✓ OK</span>
                </td>
                <td>
                  <span class="dc-mode-pill" [ngClass]="modeIconClass(r.modeEncaissement)">
                    <i class="fal" [ngClass]="modeIcon(r.modeEncaissement)"></i>
                    {{ modeLabel(r.modeEncaissement) }}
                  </span>
                </td>
                <td class="dc-ref-cell">{{ r.referenceEncaissement || '—' }}</td>
                <td class="dc-date-cell">{{ r.dateCashEncaissement | date:'dd/MM/yy HH:mm' }}</td>
                <td class="dc-note-cell">
                  <span *ngIf="r.noteEncaissement" [title]="r.noteEncaissement" class="dc-note-text">
                    {{ r.noteEncaissement | slice:0:30 }}{{ r.noteEncaissement.length > 30 ? '…' : '' }}
                  </span>
                  <span *ngIf="!r.noteEncaissement" class="dc-dash">—</span>
                </td>
                <td class="dc-actions-cell">
                  <button class="dc-btn-valider" (click)="validerEncaissement(r.id, true)" title="Valider">
                    <i class="fal fa-check"></i> Valider
                  </button>
                  <button class="dc-btn-rejeter" (click)="validerEncaissement(r.id, false)" title="Rejeter">
                    <i class="fal fa-times"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <!-- ── Onglet 2 : Livrées sans déclaration livreur ──────────── -->
      <ng-container *ngIf="ongletActif === 'SANS_DECLARATION'">
        <div class="dc-alerte-info">
          <i class="fal fa-info-circle"></i>
          Ces commandes ont le statut <strong>LIVRÉ</strong> mais le livreur n'a pas encore confirmé
          l'encaissement sur son application mobile. Contactez le livreur concerné.
        </div>
        <div class="dc-empty" *ngIf="lignesSansDeclaration.length === 0">
          <i class="fal fa-check-circle" style="font-size:2.5rem;color:#22c55e;margin-bottom:8px;"></i>
          <p>Tous les livreurs ont déclaré leurs encaissements</p>
        </div>
        <div class="dc-table-wrap" *ngIf="lignesSansDeclaration.length > 0">
          <table class="dc-table">
            <thead>
              <tr>
                <th>Commande</th>
                <th>Livreur</th>
                <th>Montant attendu</th>
                <th>Mode paiement client</th>
                <th>Date livraison</th>
                <th>Délai sans déclaration</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of lignesSansDeclaration" class="dc-row--alerte">
                <td><span class="dc-cmd-num">{{ r.numeroCommande }}</span></td>
                <td>
                  <span class="dc-livreur">
                    <i class="fal fa-user-circle" style="color:#f97316"></i>
                    {{ r.livreurNom || '—' }}
                  </span>
                </td>
                <td class="dc-num-cell"><strong>{{ formaterFCFA(r.montantAttendu) }}</strong></td>
                <td>
                  <span class="dc-mode-pill" [ngClass]="modeIconClass(r.modePaiement)" *ngIf="r.modePaiement">
                    <i class="fal" [ngClass]="modeIcon(r.modePaiement)"></i>
                    {{ modeLabel(r.modePaiement) }}
                  </span>
                  <span *ngIf="!r.modePaiement" class="dc-dash">—</span>
                </td>
                <td class="dc-date-cell">{{ r.dateLivraison | date:'dd/MM/yy HH:mm' }}</td>
                <td>
                  <span class="dc-delai-badge" *ngIf="r.dateLivraison">
                    <i class="fal fa-clock"></i> {{ delaiJours(r.dateLivraison) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

    </div>
  </ng-container>

  <div *ngIf="!chargement && !data" class="dc-erreur">
    <i class="fal fa-wifi-slash" style="font-size:2rem;margin-bottom:8px;"></i>
    <p>Impossible de charger le tableau de bord.</p>
    <button class="btn btn-primary" (click)="recharger()">Réessayer</button>
  </div>

</section>
